<template>
  <div>
    <b-modal
      id="modal-edit"
      size="xl"
      centered
      :title="$store.state.modal.editUser"
      header-bg-variant="warning"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group :label="$store.state.form.username" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('username')"
            v-model="$v.data.username.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.email" label-cols-md="3">
          <b-form-input
            type="email"
            :state="checkIfValid('email')"
            v-model="$v.data.email.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.nip" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('NIP')"
            v-model="$v.data.NIP.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.nomorTelepon" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('nomorTelepon')"
            v-model="$v.data.nomorTelepon.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.karyawan" label-cols-md="3">
          <b-form-input
            class="w-100"
            v-model="data.namaKaryawan"
            disabled
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.mitra" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.mitra"
            :options="listMitra"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            track-by="id"
            :placeholder="$store.state.form.placeholderMitra"
            disabled
          ></Multiselect>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" @click="cancel()">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button :disabled="busy || !isValid" variant="primary" @click="save">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  props: ["data", "listMitra", "listKaryawan"],
  data() {
    return {
      // options,
      button: "Simpan",
      busy: false,
      role: [
        { value: null, text: "" },
        { value: "karyawan", text: "Karyawan" },
        { value: "supervisor", text: "Supervisor" },
        { value: "admin_hrd", text: "Admin HRD" },
      ],
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      username: { required },
      email: { required, email },
      NIP: {},
      nomorTelepon: { required },
      password: { required },
      // mitra: { required },
      // karyawan: { required },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    save() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      console.log(vm.data);
      vm.$axios
        .post("user/updateAdmin", vm.data)
        .then((res) => {
          console.log("res update user", res);
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.data.nama = "";
            vm.data.password = "";
            vm.data.nip = "";
            vm.data.role = "";
            vm.$bvModal.hide("modal-edit");
            vm.$emit("alertFromChild", {
              showing: true,
              variant: "success",
              msg: "BERHASIL MENGUBAH DATA PENGGUNA",
            });
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$bvModal.hide("modal-edit");
            vm.$emit("alertFromChild", {
              showing: true,
              variant: "danger",
              msg: res.data.message.toUpperCase(),
            });
          }
        })
        .catch(() => {
          vm.$bvModal.hide("modal-edit");
          vm.$emit("alertFromChild", {
            showing: true,
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
          });
        });
    },
    cancel() {
      this.$bvModal.hide("modal-edit");
    },
  },
};
</script>
